module.exports = __webpack_public_path__ + "static/media/berserk.e3a188ce.png";